<template>

	<div
			:class="{ 'video-slide--initiated': initiated }"
			class="embed-responsive embed-responsive-16by9 video-slide"
			style="overflow: hidden;"
	>
		<img
				:src="imgUrl"
				:class="{ 'd-none': playing }"
				@click="player.playVideo()"
				class="img-fluid w-100 video-img" alt=""
		>
<!--		<i-->
<!--				:class="{ 'd-none': playing || !initiated }"-->
<!--				@click="player.playVideo()"-->
<!--				class="play-icon"-->
<!--		>-->
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="75.5"
				 height="75.5" style="width: auto;">
				<path opacity=".8"
					  d="M37.74.38A37.36 37.36 0 0 0 .37 37.75a37.4 37.4 0 0 0 37.38 37.38 37.36 37.36 0 0 0 37.37-37.37A37.4 37.4 0 0 0 37.74.38"/>
				<g opacity=".9">
					<defs>
						<path id="a" d="M0 0h75.5v75.5H0z"/>
					</defs>
					<clipPath id="b">
						<use xlink:href="#a" overflow="visible"/>
					</clipPath>
					<path clip-path="url(#b)" fill="#FFF"
						  d="M37.74 0A37.73 37.73 0 0 0 0 37.76a37.77 37.77 0 0 0 37.76 37.76A37.73 37.73 0 0 0 75.5 37.76 37.77 37.77 0 0 0 37.74.02m-9.82 51.12V23.66l26.36 13.77-26.36 13.7z"/>
				</g>
			</svg>
		</i>
		<div :class="{ 'd-none': !playing }">
			<youtube
					ref="youtube"
					@playing="play()"
					@paused="stop()"
					@ended="stop()"
					:player-vars="{ controls: 0, autoplay: 0, showinfo: 0 }"
			></youtube>
		</div>
	</div>

</template>

<script>
	import VueYoutube from 'vue-youtube';
	// const youtubePlayer = require('youtube-player')

	export default {

		components: {
			VueYoutube
		},

		props: {
			videoId: String,
			imgUrl: String
		},

		data() {
			return {
				initiated: false,
				playing: false
			}
		},

		computed: {
			player() {
				return this.$refs.youtube.player
			}
		},

		mounted() {
			this.player.loadVideoById(this.videoId)
		},

		methods: {
			play() {
				if (!this.initiated) {
					this.player.pauseVideo();
					this.initiated = true;
				} else {
					this.playing = true;
				}
			},

			stop() {
				this.playing = false;
			}
		}
	}
</script>

<style lang="scss">
	.video-slide {
		.video-img {
			position: absolute;
			top: 0;
			right: 0;
			z-index: 1;
		}

		.play-icon {
			cursor: pointer;
			position: absolute;
			top: 50%;
			left: 50%;
			z-index: 9;
			transform: translate(-50%, -50%);
		}

		&--initiated {
			.video-img {
				cursor: pointer;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/YoutubeSlide.vue